import ContractorEdit from "./ContractorEdit";

export default ContractorEdit;
